import useWidth from './useWidth';
import { isMobile } from 'react-device-detect';

const useMobile = () => useWidth() <= 921 || isMobile;

export default useMobile;
